<template>
  <footer class="site-footer">
    <div class="footer-legal">
      <div class="flex flex-between content-max-width">
        <div class="col">
          <img src="/images/icons/logo-icon.png" alt="" class="logo">
          <a href="#" class="tel">{{ content.phone }}</a>
          <a href="mailto:careers@glasslines.co.nz" class="email">{{ content.email_to }}</a>
          <p class="copyright desktop">© 2020 {{ content.site_name }}.
            <a
              href="http://www.brownpaperbag.co.nz/"
              target="_blank"
              class="attribution"
            >Web Design by Brownpaperbag
            </a>
          </p>
        </div>
        <div class="col">
          <div class="flex social">
            <div class="icon">
              <a href="#"><img src="/images/icons/fb.svg" alt=""></a>
            </div>
            <div class="icon">
              <a href="#"> <img src="/images/icons/ig.svg" alt=""></a>
            </div>
          </div>
          <ul>
            <li><a href="/careers">Careers</a></li>
            <li><a href="/lifestyle">Lifestyle</a></li>
            <li><a href="#">About Us</a></li>
          </ul>
          <p class="copyright mobile">© 2020 Glasslines NZ Ltd.
            <a
              href="http://www.brownpaperbag.co.nz/"
              target="_blank"
              class="attribution"
            >Web Design by Brownpaperbag
            </a>
          </p>
        </div>


      </div>
    </div>
  </footer>
</template>

<script>
export default {
  props: ['content']
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Footer.vue